import React, {useState} from "react";
import Button from "reactstrap/lib/Button";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalHeader from "reactstrap/lib/ModalHeader";
import {t} from "react-switch-lang";
import DeactivateUser from "../../app/administration/users/components/DeactivateUser";
import Trash from "../../app/administration/users/trash.png";
import "./Modals.scss";
import Exclusion from "./img/Exclusion 2.svg";

export function Deactivate(props) {

    const [modal, setModal] = useState(false);
    const userModal = () => setModal(!modal);

    var buttonText = "";
    if (props.data.activated === true) {
        buttonText = t("buttons.deactivateBtn");
    } else {
        buttonText = t("buttons.activateBtn");
    }


    return (
        <>
            {/* {userData.id !== props.data.id && ( */}
                <Button className="danger modal-open-button"
                        onClick={userModal}>
                    <img src={Trash} alt="icon"/>
                    <span>{buttonText}</span>
                </Button>
            {/* )}  */}
            <Modal
                isOpen={modal}
                toggle={userModal}
                className="modal-md modalDelete"
                backdrop="static"
            >
                <ModalHeader toggle={userModal}>
                    <div>
                        {buttonText} {t("users.user")}
                    </div>
                    <img src={Exclusion} alt="Exclusion" onClick={userModal}
                         style={{cursor: "pointer"}}/>
                </ModalHeader>
                <ModalBody className="d-flex flex-row">
                    <div>
                        <div className="row">
                            <div className="py-2 my-2">
                                <h3>{`${
                                    props.data.activated
                                        ? t("question.deactivate")
                                        : t("question.activate")
                                } ${props.data.login}  ?`}</h3>
                            </div>
                            <div
                                className="container-fluid decorationLine"></div>
                            <div className="text-righ offset-5">
                                <Button onClick={userModal}
                                        className="danger cancelButton">
                                    {t("buttons.cancelBtn")}
                                </Button>
                            </div>
                            <div className="text-right">
                                <div className="text-right">
                                    <DeactivateUser
                                        data={props.data}
                                        toggleModal={() => setModal(false)}
                                        setRowChanged={() => props.setRowChanged()}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}
